import * as Msal from 'msal'
import { storeItem } from './local-storage'
import { InteractionRequiredAuthError } from 'msal'

const ScopeUri = `https://bakerbookhouse.onmicrosoft.com/${process.env.VUE_APP_B2C_ENV}-bbh-ecomm-api/`
const Scopes = [
  'user_impersonate'
]
const B2C_SCOPES = Scopes.map(s => ScopeUri + s)

let msalApp

const initUserAgent = (authority) => {
  const config = {
    auth: {
      clientId: process.env.VUE_APP_B2C_CLIENT_ID,
      authority: authority || process.env.VUE_APP_B2C_AUTHORITY,
      validateAuthority: false,
      navigateToLoginRequestUrl: false,
      redirectUri: process.env.VUE_APP_URL + '/auth/callback',
      postLogoutRedirectUri: process.env.VUE_APP_URL + '/auth/signed-off'
    },
    cache: {
      cacheLocation: 'sessionStorage'
    }
  }
  const userAgent = new Msal.UserAgentApplication(config)
  userAgent.handleRedirectCallback(tokenReceivedCallback)
  return userAgent
}

export const azureADSignIn = (authority = null) => {
  const value = authority || process.env.VUE_APP_B2C_AUTHORITY
  msalApp = initUserAgent(value)
  msalApp.loginRedirect({ scopes: B2C_SCOPES })
}

export const acquireTokenSilent = () => {
  if (!msalApp) {
    msalApp = initUserAgent()
  }
  return msalApp.acquireTokenSilent({ scopes: B2C_SCOPES })
}

export const azureADSignOut = () => {
  if (!msalApp) {
    msalApp = initUserAgent()
  }
  msalApp.logout()
}

export const azureADGetUser = () => {
  if (!msalApp) {
    msalApp = initUserAgent()
  }
  return msalApp.getAccount()
}

export const tokenReceivedCallback = (error) => {
  if (!error) {
    return
  }
  if (error.errorMessage.includes('AADB2C90118')) { // forgot password error
    storeItem('force_auth_on_callback', true)
    const forgotPassAuthority = process.env.VUE_APP_B2C_FORGOT_PASS_URL
    if (!msalApp) {
      msalApp = initUserAgent(forgotPassAuthority)
    }
    msalApp.loginRedirect()
  } else if ((error instanceof InteractionRequiredAuthError || error.errorCode === 'user_login_error')) {
    azureADSignIn()
  }
}
